import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import Ripple from 'vuetify/lib/directives/ripple';

Vue.use(Vuetify, {
  directives: {
    Ripple,
  },
});

export default function createVuetify(config) {
  return new Vuetify({
    theme: {
    themes: {
      light: {
        //primary: "#4a1cd4",
        //primary: "#cd362b",
        primary: config?.branding?.primaryColour || "#7832DC",
        secondary: config?.branding?.secondaryColour || "#b3a4f2",
      },
    },
  },
  });
}

